import { render, staticRenderFns } from "./Disposition.vue?vue&type=template&id=42953ca7"
import script from "./Disposition.vue?vue&type=script&lang=js"
export * from "./Disposition.vue?vue&type=script&lang=js"
import style0 from "./Disposition.vue?vue&type=style&index=0&id=42953ca7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports